import React from 'react';
import ArrayUtil from '@leverege/array-util';
import { GlobalState } from '@leverege/ui-redux';
import { Toast } from '@leverege/ui-elements';
import { EditorDialog } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import Rsrc from "../Rsrc.js";
import Icons from "../Icons.js";
import EditUserRolesEditor from "./EditUserRolesEditor.js";
const {
  t
} = I18N.ns('userManagement.user.EditUserRolesDialog');

/**
 * Add user dialog.
 */
export default class EditUserRolesDialog extends React.Component {
  /**
   * Constructs component.
   */
  constructor(props) {
    super(props);
    this.state = {
      okayLabel: Rsrc.editUserRolesOkay
    };
  }

  /**
   * Handles dialog completion events.
   */
  onOkay = async event => {
    return this.onUpdateUser(event);
  };
  async onUpdateUser(event) {
    // Get parameters
    const {
      actions,
      onClose
    } = event.data;
    const {
      user,
      roles,
      originalRoles
    } = event.value;
    const rolesDiff = ArrayUtil.diffByKey(originalRoles, roles, 'id');

    // Validate parameters
    if (user?.id == null) {
      console.log('User id must be defined');
      return;
    }

    // Update roles
    try {
      if (rolesDiff.added.length > 0) {
        await GlobalState.dispatch(actions.user(user.id).addRoles(rolesDiff.added.map(r => r.id)));
      }
      if (rolesDiff.removed.length > 0) {
        await GlobalState.dispatch(actions.user(user.id).removeRoles(rolesDiff.removed.map(r => r.id)));
      }
    } catch (error) {
      Toast.error([t('toastError'), error.message]);
      onClose();
      return;
    }

    // Successfully updated user
    Toast.success([t('toastSuccess')]);
    onClose();
  }

  /**
   * Validator to enable submission button.
   */
  validator = data => {
    if (data == null) {
      return false;
    }
    const {
      roles,
      originalRoles
    } = data;
    if (roles == originalRoles) {
      return false;
    }
    if (roles == null || originalRoles == null) {
      return true;
    }
    if (roles.length !== originalRoles.length) {
      return true;
    }
    const set = new Set();
    roles.forEach(r => {
      set.add(r.id);
    });
    return originalRoles.some(r => {
      return !set.has(r.id);
    });
  };

  /**
   * Renders component.
   */
  render() {
    // Get parameters
    const {
      show,
      onClose,
      projectId,
      selectorProps,
      actions,
      Selector,
      edit,
      user,
      editorVariants
    } = this.props;
    const {
      okayLabel
    } = this.state;

    // Render component
    return /*#__PURE__*/React.createElement(EditorDialog, {
      icon: Icons.addDialogIcon,
      title: Rsrc.editUserRolesTitle(user),
      okayLabel: okayLabel,
      eventData: this.props,
      show: show,
      onClose: onClose,
      onOkay: this.onOkay,
      validator: this.validator,
      editor: EditUserRolesEditor,
      editorVariants: {
        pane: 'userRolesEditor|rootEditor|form',
        header: 'userRolesEditorHeader|rootEditorHeader|formHeader',
        body: 'userRolesEditorContent|rootEditorContent|formBody',
        title: 'userRolesEditorTitle|rootEditorTitle|formTitle',
        footer: 'userRolesEditorFooter|rootEditorFooter|formFooter',
        ...editorVariants
      },
      editorProps: {
        selectorProps,
        projectId,
        actions,
        edit,
        user,
        roleSelector: Selector,
        setDialogTitle: title => {
          this.setState({
            title
          });
        },
        setDialogOkayLabel: okayLabel => {
          this.setState({
            okayLabel
          });
        }
      }
    });
  }
}